import { useStyle } from "@/context/StyleContext";
import { Collapse } from "@mui/material";
import React from "react";
import { Text } from "@/components/text/Text";

import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import DefaultButton from "../buttons";

export const Card = ({
  children,
  style,
  source = null,
  imageStyle,
  contentContainerStyle,
}: {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  contentContainerStyle?: React.CSSProperties;
  source?: any;
}) => {
  const { colors, theme } = useStyle();

  return (
    <div
      style={{
        ...{
          border: `1px solid ${colors[theme].border}`,
          backgroundColor: colors[theme].background,
          padding: "16px",
          borderRadius: "16px",
        },
        ...style,
      }}
    >
      {/* Image placeholder */}
      {source && (
        <img
          src={source}
          alt="Card Image"
          style={{
            ...{
              height: "100%",
              aspectRatio: "9/16",
              objectFit: "cover",
            },
            ...imageStyle,
          }}
        />
      )}
      <div
        style={{
          ...{
            padding: "24px",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          },
          ...contentContainerStyle,
        }}
      >
        {children}
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            // borderBottom: `1px solid ${colors[theme].text}`,
          }}
        ></div>
      </div>
    </div>
  );
};
